import AdminCustomerHeader from './AdminCustomerHeader.js'
import { useLocation } from 'react-router-dom';

const AdminCustomerAccount = () => {
    const location = useLocation();
    // console.log('✌️location --->', location);
    return (
        <>
            <AdminCustomerHeader location={location?.state} />
        </>
    )
}

export default AdminCustomerAccount
